import { useMutation, useQueryClient } from '@tanstack/react-query';
import ArticlesService from '../services/articles.service';
import { Article } from '../common/model/dto/article';

export function useAdminArticleMutations() {
  const qc = useQueryClient();

  const onArticleSaved = (article: Article) => {
    qc.setQueryData(['admin-article', article.id], article);
    qc.invalidateQueries({ queryKey: ['admin-articles'] });
  };

  const createArticle = useMutation({
    mutationFn: (article: Article) => ArticlesService.createArticle(article),
    onSuccess: onArticleSaved,
  });

  const updateArticle = useMutation({
    mutationFn: (article: Article) => ArticlesService.updateArticle(article),
    onSuccess: onArticleSaved,
  });

  const deleteArticle = useMutation({
    mutationFn: (articleId: string) => ArticlesService.deleteArticle(articleId),
    onSuccess: (_, articleId) => {
      qc.removeQueries({ queryKey: ['admin-article', articleId] });
      qc.invalidateQueries({ queryKey: ['admin-articles'] });
    },
  });

  return { createArticle, updateArticle, deleteArticle };
}
